import {Component} from "@angular/core";
import {FormControl, FormGroup, NgForm} from "@angular/forms";

@Component({
  template: `
    <div class="container">
      <div class="row mb-5">
        <div class="col-6">
          <form [formGroup]="form">
            <select-country [formControlName]="'country'"></select-country>
          </form>
        </div>
        <div class="col-6">
          <pre class="debug">value = {{ form.controls["country"].value }}, dirty = {{ form.controls["country"].dirty }}</pre>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-6">
          <form #manualForm="ngForm">
            <select-country name="country" [(ngModel)]="country"></select-country>
          </form>
        </div>
        <div class="col-6">
          <pre class="debug">value = {{ country }}, dirty = {{ manualForm.dirty }}</pre>
        </div>
      </div>
      <div class="row mb-5">
        <div class="btn-group float-right">
          <button class="btn btn-outline-primary" (click)="simulatePreload()">Simulate Preload</button>
        </div>
      </div>
    </div>
`,
})
export class TestComponent {
  form: FormGroup = new FormGroup({
    country: new FormControl(""),
  });

  manualForm: NgForm;
  country: string = "";

  simulatePreload() {
    const country = "US";
    this.country = country;
    this.form.setValue({country});
  }
}
